import React, { useEffect } from 'react';
import { FAQSection } from '../components/FAQSection';
export function FAQPage() {
  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <main className="min-h-screen bg-cream pt-20" data-id="element-505">
      <FAQSection data-id="element-506" />
    </main>;
}